import { CaseGranulometry } from '../../../CaseGranulometry';
import { getLevelParkingsSurface } from '../../../../levels/queries/basementLevels/surfaces/getBasementLevelParkingsSurface';
import { Surface } from '../../../../../specification/Surface';
import { getCaseLevels } from '../../levels/getCaseLevels';

export const getCaseParkingsSurface = (caseGranulometry: CaseGranulometry): Surface =>
  Surface.sum(getCaseLevels(caseGranulometry).map(getLevelParkingsSurface));
